import * as React from 'react'
import { useLocation } from 'react-router-dom'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faClose } from '@fortawesome/free-solid-svg-icons'
import { controlState } from '../../store/controlState.ts'
// import SelectPet from '../common/SelectPet/SelectPet.tsx'
import { ScrollControl } from './ScrollControl.tsx'
// import { useLocation, useNavigate } from 'react-router-dom'
import { useViewTransitionNavigate } from '../../hooks/useViewTransitionNavigate.ts'


export const EventViewer: React.FC = () => {
    const location = useLocation()
    const { navigate } = useViewTransitionNavigate()
    const pet = location?.state?.pet
    
    // // const navigate = useNavigate()
    // const isMobile = useSnapshot(controlState).isOnMobileDevice
    //
    return (
        <div className={`flex flex-col w-full h-full justify-start gap-2 p-4 bg-base-100`}>
            <div className={`flex flex-col flex-1 min-h-0 gap-2 max-w-3xl mx-auto w-full`}>
                <div className={'flex flex-row w-full items-center justify-center px-1'}>
                    <div className={'text-2xl font-bold text-primary'}>
                        {pet?.petName}'s Events
                    </div>
                </div>
                <div className={'flex flex-col flex-1 min-h-0 rounded-lg bg-primary/5 border-4 border-primary/20 overflow-hidden'}>
                    <ScrollControl selectedPetId={pet!._id}/>
                </div>
            </div>
            <div className={'max-w-3xl mx-auto w-full'}>
                <input
                    type={'button'}
                    className={'btn btn-ghost text-primary shrink-0'}
                    onClick={() => navigate('/' + controlState.currentPage)}
                    value={'Close'}
                />
            </div>
        </div>
    )
}
